(function () {
  function patchAndInit() {
    if (typeof jQuery === 'undefined') {
      console.warn('custom.js: jQuery still not found');
      return;
    }

    if (!jQuery.debounce) {
      jQuery.debounce = function (delay, fn) {
        var timer = null;
        return function () {
          var context = this, args = arguments;
          clearTimeout(timer);
          timer = setTimeout(function () {
            fn.apply(context, args);
          }, delay);
        };
      };
    }

    if (!jQuery.fn.prepareTransition) {
      jQuery.fn.prepareTransition = function () {
        this.each(function () {
          this.offsetHeight; // force reflow
        });
        return this;
      };
    }

    // Re-run theme init now that the plugins exist
    try {
      if (window.theme && theme.Header && theme.Header.init) {
        theme.Header.init();
      }
    } catch (e) { console.error('theme.Header.init failed:', e); }

    try {
      if (window.theme && theme.MobileNav && theme.MobileNav.init) {
        theme.MobileNav.init();
      }
    } catch (e) { console.error('theme.MobileNav.init failed:', e); }
  }

  if (document.readyState === 'complete') {
    patchAndInit();
  } else {
    window.addEventListener('load', patchAndInit);
  }
})();